exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button_2xxIm {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    border: none;\n    border-radius: 4px;\n    height: 16px;\n    min-width: 16px;\n    background-color: transparent;\n    cursor: pointer;\n    outline: none;\n}\n\n.icon_3Q2sg {\n    fill: var(--black-200);\n    height: 16px;\n    width: 16px;\n}\n\n.button_2xxIm:active .icon_3Q2sg {\n    fill: var(--black-300);\n}\n\n.button_2xxIm:focus {\n    outline: none;\n}\n\n.button_2xxIm:active {\n    outline: none;\n}\n\n.button_2xxIm:disabled .icon_3Q2sg {\n    fill: var(--black-100);\n    cursor: auto;\n}\n\n.button_2xxIm:focus {\n    box-shadow: 0 0 0 2px var(--primary-500);\n}\n", ""]);

// exports
exports.locals = {
	"button": "button_2xxIm",
	"icon": "icon_3Q2sg"
};